import { Component, OnDestroy, ViewChild, effect, input, output } from '@angular/core';
import { QaiButtonComponent, QaiDialogComponent } from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';
import { CallStoreService } from '../../library/call-store/call-store.service';

@Component({
  selector: 'app-assessment-exit-modal',
  standalone: true,
  templateUrl: './assessment-exit-modal.component.html',
  styleUrls: ['./assessment-exit-modal.component.scss'],
  imports: [QaiDialogComponent, QaiButtonComponent, TranslocoModule],
})
export class AssessmentExitModalComponent implements OnDestroy {
  @ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;
  readonly open = input(false);
  readonly titleKey = input('learningPathway.ASSESSMENT_EXIT_MODAL_TITLE');
  readonly descriptionKey = input('learningPathway.ASSESSMENT_EXIT_MODAL_DESC');

  readonly confirmExit = output<void>();
  readonly resume = output<void>();

  constructor(private callStore: CallStoreService) {
    effect(() => {
      if (this.open()) {
        this.dialogRef?.showModal();
        this.callStore.registerModalOpen();
      } else {
        this.dialogRef?.close();
        this.callStore.registerModalClosed();
      }
    });
  }

  onConfirmExit(): void {
    this.dialogRef?.close();
    this.confirmExit.emit();
  }

  onResume(): void {
    this.dialogRef?.close();
    this.resume.emit();
  }

  ngOnDestroy(): void {
    if (this.open()) {
      this.callStore.registerModalClosed();
    }
  }
}
